type CurrencyTextProps = {
    cp: number;
    sp: number;
    ep: number;
    gp: number;
    pp: number;
};

function CurrencyText({ 
    cp,
    sp,
    ep,
    gp,
    pp,
} : CurrencyTextProps) {
    const parts: string[] = [];
    if (pp > 0) parts.push(`${pp} pp`);
    if (gp > 0) parts.push(`${gp} gp`);
    if (ep > 0) parts.push(`${ep} ep`);
    if (sp > 0) parts.push(`${sp} sp`);
    if (cp > 0) parts.push(`${cp} cp`);

    return (
        <span>
            {parts.join(', ')}
        </span>
    );
}

export default CurrencyText;